export default __webpack_public_path__ + "static/media/grafema_+-identity_04.130b5981.jpg";